





























































import { defineComponent, ref, toRefs } from '@nuxtjs/composition-api';
import { IBlokSingleImage } from '~/components/storyblok/SingleImage.vue';
import type { PropType } from '@nuxtjs/composition-api';
import { IconArrowSmallRight } from '~/components/General/icons';

interface TabItem {
  _uid: string;
  title: string;
  image: IBlokSingleImage[];
  // TODO: Set SbLink type after merge PR Sb url resolver
  link: {
    cached_url: string;
    fieldtype: string;
    linktype: string;
  };
}

interface Tab {
  _uid: string;
  title: string;
  items: TabItem[];
}

interface Blok {
  _uid: string;
  title: string;
  tabs: Tab[];
  image?: IBlokSingleImage[];
}

export default defineComponent({
  name: 'CategoriesSection',
  components: {
    IconArrowSmallRight,
  },
  props: {
    blok: {
      type: Object as PropType<Blok>,
      required: true,
    },
  },
  setup(props) {
    const { blok } = toRefs(props);
    const { tabs } = blok.value;
    // eslint-disable-next-line no-underscore-dangle
    const activeTab = ref(tabs[0]._uid);

    const setActiveTab = (tabId: string) => {
      if (tabId === activeTab.value) return;
      activeTab.value = tabId;
    };

    // eslint-disable-next-line no-underscore-dangle
    const getActiveTab = (tabId: string) => tabs.find((tab) => tab._uid === tabId);

    return {
      tabs,
      activeTab,
      setActiveTab,
      getActiveTab,
    };
  },
});
